import React, { FC } from 'react';
import { ConsentCheckListHeadersProps } from './ConsentsListItem.types';
import { HeaderSection } from '../../../../molecules/HeaderSection';

export const ConsentHeaderList: FC<ConsentCheckListHeadersProps> = ({
  consentHeader,
  headerTextStyle,
  headerFontSize,
  subHeaderTextStyle,
  subHeaderFontSize,
  onLinkClickInHeaderOrCheckbox,
}) => {
  if (!consentHeader || consentHeader.length === 0) {
    return null; // Return null if no headers are provided
  }
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {consentHeader?.map((header, headerIndex) => (
        <HeaderSection
          key={`header-${headerIndex}`}
          heading={header.header}
          subHeading={header.subHeader}
          description={header.description}
          headingClass={header.headerClassName}
          subHeadingClass={header.subHeaderClassName}
          headerTextStyle={headerTextStyle}
          headerFontSize={headerFontSize}
          subHeaderTextStyle={subHeaderTextStyle}
          subHeaderFontSize={subHeaderFontSize}
          onLinkClickInHeaderOrCheckbox={onLinkClickInHeaderOrCheckbox}
        />
      ))}
    </>
  );
};
